import { useSelector } from 'react-redux'
import { selectProductReserves } from 'src/features/stock-management/StockManagementSeletor'
import { NumberFmt } from 'src/utils'
import * as S from '../../ReservesTab.styles'

const TotalItems = () => {
  const { totalItems } = useSelector(selectProductReserves)

  return (
    <S.TotalItems>Total: {NumberFmt({ value: totalItems, sufix: '' })}</S.TotalItems>
  )
}

export default TotalItems
